import { CommonModule } from '@angular/common';
import { Component, Input, model } from '@angular/core';

@Component({
    selector: 'finder-simple-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    standalone: true,
    imports: [ CommonModule ]
})
export class SimpleTabComponent {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('tabTitle') title: string;
    // Use a writable input signal
    active = model<boolean>(false);

    constructor() { }

}
